import React from 'react';
import PropTypes from 'prop-types';
import VerificationBadge from '../verification/VerificationBadge';

const MemberProfileData = (props) => {
  const {
    id,
    name,
    age,
    location,
    verified,
  } = props;

  return (
    <div className="profile-data match-profile-data">
      <div className="profile-data-name">
        <div className="memberName memberName--dark memberName--large">
          <a href={`/member/${id}`}>
            <span className="memberName-name mrxs tct">{name}</span>
            <span className="memberName-age tct">
              (
              {age}
              )
            </span>
          </a>
          {verified && (
            <VerificationBadge />
          )}
        </div>
      </div>
      <div className="profile-data-location">{location}</div>
    </div>
  );
};

MemberProfileData.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  age: PropTypes.number.isRequired,
  location: PropTypes.string.isRequired,
  verified: PropTypes.bool,
};

MemberProfileData.defaultProps = {
  verified: false,
};

export default MemberProfileData;
